import React, { useMemo } from 'react';
import {
  OpFormSelect,
  OpFormSelectProps,
} from 'new-components/DLS/OpForm/formComponents/OpFormSelect/OpFormSelect';
import { allCountries } from 'country-region-data';

export const OpFormCountrySelect = ({
  ...props
}: OpFormSelectProps<string, any>) => {
  const countryOptions = useMemo(() => {
    return allCountries.map(([name, shortCode]) => ({
      key: shortCode,
      value: shortCode,
      label: name,
    }));
  }, []);

  return <OpFormSelect {...props} options={countryOptions} />;
};
